import type { Choice } from "@memorang/types";
import Box from "@memorang/ui/components/Box";

import { router } from "expo-router";
import { useLocalSearchParams } from "expo-router";
import DraggableFlatList, {
	ScaleDecorator,
	type RenderItemParams,
} from "react-native-draggable-flatlist";
import { Button } from "react-native-paper";

export type DraggableListProps = {
	items: Choice[];
	onReorder: (newItems: Choice[]) => void;
	renderItem: (
		item: Choice,
		index: number,
		drag: () => void,
	) => React.ReactNode;
	answered?: boolean;
};

export const DraggableList = ({
	items,
	onReorder,
	renderItem,
	answered,
}: DraggableListProps) => {
	const { index } = useLocalSearchParams<{
		index: string;
	}>();

	const handleSkip = () => {
		const currentItemIndex = index ? Number.parseInt(index) - 1 : 0;
		const newIndex = currentItemIndex + 1;

		router.setParams({
			index: String(newIndex + 1),
			prev: "false",
		});
	};
	return (
		<Box gap={16}>
			<DraggableFlatList
				data={items}
				onDragEnd={({ data }) => onReorder(data)}
				scrollEnabled={false}
				keyExtractor={(item) => item.id}
				renderItem={({ item, drag, getIndex }: RenderItemParams<Choice>) => (
					<ScaleDecorator activeScale={1.05}>
						{renderItem(item, getIndex() || 0, drag)}
					</ScaleDecorator>
				)}
				contentContainerStyle={{
					gap: 16,
				}}
			/>
			{!answered && (
				<Box alignSelf="flex-end">
					<Button onPress={handleSkip}>Skip</Button>
				</Box>
			)}
		</Box>
	);
};
